import React from 'react';
import PropTypes from 'prop-types';
import MetricCard from './MetricCard';

/**
 * Metric Section Component
 * Groups related metrics together in a card
 */
const MetricSection = ({
  title,
  icon,
  metrics = [],
  loading = false,
  description
}) => {
  return (
    <section className="metric-section">
      <div className="metric-section-header">
        <h2 className="metric-section-title">
          {icon && <i className={`bi ${icon} metric-section-icon`}></i>}
          {title}
        </h2>
        {description && <p className="metric-section-description">{description}</p>}
      </div>
      
      <div className="metric-section-grid">
        {metrics.map(metric => (
          <MetricCard
            key={metric.id}
            title={metric.title}
            value={metric.value}
            formatType={metric.formatType}
            icon={<i className={`bi ${metric.icon}`}></i>}
            color={metric.color}
            subtitle={metric.subtitle}
            trend={metric.trend}
            loading={loading}
            showIcon={true}
            metricId={metric.metricId || metric.id}
          />
        ))}
      </div>
    </section>
  );
};

MetricSection.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  metrics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      formatType: PropTypes.oneOf(['number', 'currency', null]),
      icon: PropTypes.string.isRequired,
      color: PropTypes.string,
      subtitle: PropTypes.string
    })
  ).isRequired,
  loading: PropTypes.bool,
  description: PropTypes.string
};

MetricSection.defaultProps = {
  icon: null,
  loading: false,
  description: null
};

export default React.memo(MetricSection);

